import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { Observable } from 'rxjs';
import { RepairsDashboard } from '@app/interfaces/repairs-dashboard';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class RepairDashboardService {

    constructor(private http: HttpClient, private configService: ConfigurationService) { }

    getRepairDashboard(userId: string, tenancyReference: string, startDate: string, endDate: string): Observable<RepairsDashboard> {
        const repairsApiUrl = this.configService.getConfig()?.shell.api.repairsApiUrl;
        //const repairsApiUrl = 'https://connect.api.local/repairs/'//this.configService.getConfig()?.shell.api.repairsApiUrl;
        return this.http.get<RepairsDashboard>(repairsApiUrl + 'repairsDashboard?userId=' + userId + '&tenancyReference=' + tenancyReference + '&startDate=' + startDate + '&endDate=' + endDate)

    }
}
